import BaseApi from '../BaseApi';

class UploadImageApi extends BaseApi {
  public uploadImage(params: any) {
    return this.post('signed-url', params);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/';
  }
}

export default UploadImageApi;
